import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import $rq from '@/api/api';
import type { Product } from '@/interfaces/common';

// Local interfaces
interface ProductState {
    product: Product;
}
// Default state
const defaultState: ProductState = {
    product: {},
};

export const productModule: Module<ProductState, RootState> = {
    state: { ...defaultState },

    getters: {
        /**
         * Flatten file list into root object
         */
        product: (state: ProductState): Product => {
            const { files, ...props } = state.product || {};
            return {
                ...props,
                ...(files || {}),
            } as Product;
        },
    },

    mutations: {
        setProductState(state: ProductState, product: Product): void {
            state.product = product;
        },
        resetProductState(state: ProductState): void {
            Object.assign(state, { ...defaultState });
        },
    },

    actions: {
        async getProductInfo({ commit, dispatch }, productId: string): Promise<void> {
            try {
                const { data } = await $rq.getProduct(productId, { showallattributes: true });
                commit('setProductState', data);
            } catch (err) {
                console.error('Error fetching product info:', err);
                dispatch('resetProductInfo');
            }
        },

        async getSiteProductInfo(
            { commit, dispatch },
            { siteId, productId }: { siteId: string; productId: string },
        ): Promise<void> {
            try {
                const { data } = await $rq.getSiteProduct(siteId, productId, {
                    showallattributes: true,
                });
                commit('setProductState', data);
            } catch (err) {
                console.error('Error fetching site product info:', err);
                dispatch('resetProductInfo');
            }
        },

        async getClientProductInfo(
            { commit, dispatch },
            { clientId, productId }: { clientId: string; productId: string },
        ): Promise<void> {
            try {
                const { data } = await $rq.getClientProduct(clientId, productId, {
                    showallattributes: true,
                });
                commit('setProductState', data);
            } catch (err) {
                console.error('Error fetching client product info:', err);
                dispatch('resetProductInfo');
            }
        },

        resetProductInfo({ commit }): void {
            commit('resetProductState');
        },
    },
};
